import { useEffect } from 'react';

function selectionTarget(node) {
  if (!(node instanceof Element)) return null;
  const book = node.closest('.home-gold-surface .bible-list a');
  if (book) return book;
  if (!node.closest('.bibleframe .content section')) return null;
  const block = node.closest('.bible-reading-verse, .gal-verse, .hebrew-verse');
  if (block) return block;
  // Older editions contain nested verse spans and a separate verse number.
  let verse = node.closest('span[id="verse"]');
  if (!verse) {
    const sibling = node.closest('em[id]')?.nextElementSibling;
    if (sibling?.matches('span[id="verse"]')) verse = sibling;
  }
  if (verse) {
    while (verse.parentElement?.closest('span[id="verse"]')) {
      verse = verse.parentElement.closest('span[id="verse"]');
    }
    return verse;
  }
  return node.closest('p, h1, h2, h3, h4, h5, h6, li, a');
}

export default function BibleSelectionSound() {
  useEffect(() => {
    let context;
    let lastSound = -Infinity;
    const unlock = () => {
      try {
        const AudioContext = window.AudioContext || window.webkitAudioContext;
        if (!AudioContext) return;
        if (!context) context = new AudioContext();
        if (context.state === 'suspended') context.resume().catch(() => {});
      } catch (_) { /* Sound is optional; reading must remain available. */ }
    };
    const play = () => {
      if (!context || context.state !== 'running') return;
      const now = context.currentTime;
      if (now - lastSound < 0.09) return;
      lastSound = now;
      const oscillator = context.createOscillator();
      const gain = context.createGain();
      oscillator.type = 'sine';
      oscillator.frequency.setValueAtTime(1046.5, now);
      oscillator.frequency.exponentialRampToValueAtTime(1568, now + 0.025);
      gain.gain.setValueAtTime(0, now);
      gain.gain.linearRampToValueAtTime(0.035, now + 0.004);
      gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.065);
      oscillator.connect(gain);
      gain.connect(context.destination);
      oscillator.onended = () => { oscillator.disconnect(); gain.disconnect(); };
      oscillator.start(now);
      oscillator.stop(now + 0.07);
    };
    const hover = (event) => {
      if (event.pointerType === 'touch') return;
      const target = selectionTarget(event.target);
      if (target && target !== selectionTarget(event.relatedTarget)) play();
    };
    const keydown = (event) => {
      if (!event.repeat && !event.metaKey && !event.ctrlKey && !event.altKey) unlock();
    };
    document.addEventListener('pointerdown', unlock);
    document.addEventListener('keydown', keydown);
    document.addEventListener('pointerover', hover);
    document.addEventListener('focusin', hover);
    return () => {
      document.removeEventListener('pointerdown', unlock);
      document.removeEventListener('keydown', keydown);
      document.removeEventListener('pointerover', hover);
      document.removeEventListener('focusin', hover);
      if (context && context.state !== 'closed') context.close().catch(() => {});
    };
  }, []);
  return null;
}
